import { NavigationGuard } from 'vue-router';
import useAuthStore from '@/common/store/pinia/auth';
import { useNotificationsStore } from '@/common/store/pinia/notifications';
import { NotificationType } from '@/common/constants/notifications.constants';
import i18n from '@/common/i18n';

export default (function domainModeHandler(to, from, next) {
  if (!to.matched.some(route => route.meta?.requiresDomainMode)) {
    next();
    return;
  }

  const authStore = useAuthStore();
  if (!authStore.currentUser) {
    next();
    return;
  }

  if (!authStore.isDomainAdmin || !authStore.currentUser.domain_id) {
    next('/');
    return;
  }

  if (authStore.domainMode && !authStore.isSwitchingScope) {
    next();
    return;
  }

  const comesFromDomainScreen = !!from?.matched?.some(route => route.meta?.requiresDomainMode);

  if (!authStore.domainMode && comesFromDomainScreen) {
    next('/');
    return;
  }

  authStore.switchToDomainMode().then(
    () => next(),
    () => {
      const notificationsStore = useNotificationsStore();
      notificationsStore.add({
        id: 'domain-mode-switch-failed',
        type: NotificationType.ERROR,
        title: i18n.t('Error'),
        message: i18n.t('Failed to switch to domain mode')
      });
      next('/');
    }
  );
}) as NavigationGuard;
